import { IOfferHandler } from '../../types';
import { Offer } from '../../../../services/exports/Interfaces';
import { CompleteBasketItem } from '../../../../providers/BasketProvider';

const usePercentageOffByMinSpendValue: IOfferHandler = () => {
  const isEligible = (offer: Offer, items: CompleteBasketItem[]) =>
    items.filter((item) => !item.is_free).reduce((acc, item) => acc + item.actual_price, 0) >=
    offer.details.min_spend_value;
  const getProfit = (offer: Offer, items: CompleteBasketItem[]) =>
    items.reduce((acc, item) => acc + item.actual_price, 0) * (offer.details.percentage_amount / 100);
  const apply =
    (offer: Offer) =>
    (item: CompleteBasketItem): CompleteBasketItem => {
      if (!item.actual_price) {
        return item;
      }

      if (item.is_free) {
        return item;
      }

      return {
        ...item,
        actual_price: item.actual_price * ((100 - offer.details.percentage_amount) / 100),
      };
    };

  return (offer, items) => ({
    isEligible: isEligible(offer, items),
    isUnlocked: isEligible(offer, items),
    profit: getProfit(offer, items),
    apply: apply(offer),
  });
};

export default usePercentageOffByMinSpendValue;
